import { useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import { ChatbotContext } from 'providers/ChatbotProvider';
import useFetch from 'use-http';
import useSessionStorage from 'hooks/useSessionStorage';
import { BOT_SESSION_ID } from 'constant/chat';

const useSessionMessages = () => {
    const { setSessionMessagesLoading } = useContext(ChatbotContext);
    const { post } = useFetch();
    const { getSessionStorageValue } = useSessionStorage();

    const getSessionMessages = useCallback(async () => {
        setSessionMessagesLoading(true);
        const url = `/get_messages_by_session_id_anonymous`;

        try {
            const response = await post(url, { sessionId: getSessionStorageValue(BOT_SESSION_ID) });
            const isSuccess = response?.code === 200;
            if (!isSuccess) toast.error(response?.message);

            return { isSuccess, chatMessages: response?.chatMessages };
        } catch (err) {
            console.error(err);
            toast.error('Something went wrong, please try again later');
            throw err;
        } finally {
            setSessionMessagesLoading(false);
        }
    }, [post, setSessionMessagesLoading]);

    return { getSessionMessages };
};

export default useSessionMessages;
